import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { BackfillCustomerRelationshipsRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillCustomerRelationships.pb'
import { BackfillCustomerRelationshipsResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillCustomerRelationships.pb'

export const backfillCustomerRelationships = (
  request: BackfillCustomerRelationshipsRequest,
  options?: CashRequestOptions
) =>
  post<BackfillCustomerRelationshipsRequest, BackfillCustomerRelationshipsResponse>(
    '/2.0/cash/backfill-customer-relationships',
    request,
    { ...options, rejectOnError: true }
  )
